/* global Vue, LOYALTY_API, LOYALTY_LEVELS */
import { setErrorAndStopLoading, startLoading, stopLoading } from '../../apps/components/Notifications'
import LevelsProgress from '../components/LevelsProgress'
import { AuthService, fetchWithTokenAsync } from '../../AuthService'
import { formatNumber, formatDateForMaistra } from './../../utils-common'

export default {
  name: 'Activity',
  components: { LevelsProgress },
  template: `
  <div>
    <div class="container section-margin-small-bottom">
      <div class="activity">
        <div class="grid">
          <div class="col-12 col-lg-10 offset-lg-1 col-xl-8 offset-xl-2">
            <LevelsProgress :availablePoints="availablePoints" :level="level" :expiresOn="expiresOn" :proceed="userLoyaltyLevel?.proceed"></LevelsProgress>
          </div>
        </div>

        <div class="grid">
          <div class="col-12 col-md-10 offset-md-1 col-xl-6 offset-xl-4">
            <div class="activity__buttons">
              <router-link v-show="availablePoints > 0" class="button button--outline" to="/points/transfer">{{ $t('activity.transferPoints') }}</router-link>
              <router-link class="button button--outline" to="/points/obtain">{{ $t('activity.missingPoints') }}</router-link>
            </div>
          </div>
        </div>

        <div v-if="points.length" class="grid">
          <div class="col-12 col-lg-10 offset-lg-1 col-xl-8 offset-xl-2">
            <div class="table-container">
              <table class="loyalty-table loyalty-table--activity loyalty-table--background-odd">
                <tr>
                  <th>{{ $t('activity.date') }}</th>
                  <th>{{ $t('activity.source') }}</th>
                  <th>{{ $t('activity.points') }}</th>
                </tr>
                <tr v-for="(point, index) in points">
                  <td>{{ formatDateForMaistra(point.createdOn) }}</td>
                  <td>
                    <span v-if="point.phobsId">{{ $t('activity.transactionTypes[' + point.type + ']') }} {{ getPropertyTitle(point.phobsId) }}</span>
                    <span v-else >{{ $t('activity.transactionTypes[' + point.type + ']') }}</span>
                  </td>
                  <td>{{ formatNumber(point.points) }} <span class="uppercase">{{ $t('activity.points') }}</span></td>
                </tr>
              </table>
            </div>
          </div>
        </div>
        <p v-else class="h4 text-center">{{ $t('activity.noActivity') }}</p>
      </div>
    </div>
  </div>`,
  props: {
    loyaltyId: Number,
    properties: Array,
  },
  setup (props, { emit }) {
    const points = Vue.ref([])
    const availablePoints = Vue.ref(0)
    const level = Vue.ref(0)
    const expiresOn = Vue.ref(null)

    const userLoyaltyLevel = Vue.computed(() => LOYALTY_LEVELS.find(l => l.level === level.value))

    const { loyaltyId } = Vue.toRefs(props)

    function getPropertyTitle (phobsId) {
      if (phobsId) return (props.properties.find(p => p.phobsId === phobsId))?.title
      return null
    }

    Vue.watch(loyaltyId, async () => {
      try {
        startLoading('activity-watch')
        const page = 0
        const responseActivityHistory = await fetchWithTokenAsync(`${LOYALTY_API}/api/v1/activityhistory/${page}`, AuthService.accessToken, 'GET')
        if (responseActivityHistory?.status === 2) {
          throw Error(responseActivityHistory?.message ? responseActivityHistory?.message : responseActivityHistory.status)
        }
        if (!responseActivityHistory?.activityReportItems) {
          throw Error('activityReportItems')
        }
        points.value = responseActivityHistory.activityReportItems.map(r => {
          return {
            createdOn: new Date(r.createdOn),
            phobsId: r.phobsId,
            points: r.points,
            type: r.type,
          }
        })

        const response = await fetchWithTokenAsync(`${LOYALTY_API}/api/v1/MyLoyaltyStatus`, AuthService.accessToken, 'GET')
        if (!response?.loyaltyProfile) {
          throw Error('MyLoyaltyStatus')
        }
        availablePoints.value = response.loyaltyProfile.availablePoints
        level.value = response.loyaltyProfile.levelId
        expiresOn.value = new Date(response.loyaltyProfile.expiresOn)
        stopLoading('activity-watch')
      } catch (e) {
        setErrorAndStopLoading(e)
      }
    }, { immediate: true })

    return {
      points,
      level,
      expiresOn,
      getPropertyTitle,
      availablePoints,
      userLoyaltyLevel,
      formatNumber,
      formatDateForMaistra,
    }
  },
}
